module.exports = __webpack_public_path__ + "img/homepage-about.a0f7f543.jpg";